import { render, staticRenderFns } from "./ScopeKgEvidenceTable.vue?vue&type=template&id=217f5b7f&scoped=true"
import script from "./ScopeKgEvidenceTable.vue?vue&type=script&lang=js"
export * from "./ScopeKgEvidenceTable.vue?vue&type=script&lang=js"
import style0 from "./ScopeKgEvidenceTable.vue?vue&type=style&index=0&id=217f5b7f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217f5b7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('217f5b7f')) {
      api.createRecord('217f5b7f', component.options)
    } else {
      api.reload('217f5b7f', component.options)
    }
    module.hot.accept("./ScopeKgEvidenceTable.vue?vue&type=template&id=217f5b7f&scoped=true", function () {
      api.rerender('217f5b7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealScope/ScopeKgEvidenceTable.vue"
export default component.exports